export default __webpack_public_path__ + "static/media/mail.4c06a546.svg";